import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { EMarkAsReadNotificationActionTypes, TMarkAsReadNotificationFailed } from './types';

export const markAsReadFailed: () => TMarkAsReadNotificationFailed =
  actionGenerator<EMarkAsReadNotificationActionTypes.Failed>(EMarkAsReadNotificationActionTypes.Failed);
